import { isDate } from 'lodash'
import moment from 'moment'
import Vue from 'vue'
import VueI18n from 'vue-i18n'


Vue.filter('formatDuree', function(value:Array<Date>,i18n:VueI18n,forceShowSecond:boolean = false) {
  if (value && value.length >= 2 && value[0] != null && value[1] != null && isDate(value[0]) && isDate(value[1])) {  
    const timeStart = value[0]?.getTime() ?? 0
    const timeEnd =  value[1]?.getTime()  ?? 0     
    const negatif = timeStart > timeEnd?"-":""
    const duration = moment.duration(Math.abs(timeEnd - timeStart))    
    const durationMs = duration.asMilliseconds()    
    if(isNaN(durationMs)) return ''
    
    if(durationMs >= 24 * 60 * 60 * 1000) return negatif + duration.asDays().toFixed(1) + ' '+ i18n.tc('Pilot.MissionDrawer.Days', parseFloat(duration.asDays().toFixed(1)))
    else if(durationMs >= 60 * 60 * 1000) return negatif + duration.hours() + 'h ' + duration.minutes() + 'min' + (forceShowSecond?(' ' + duration.seconds() + 's'):'')
    else if(durationMs >= 60 * 1000) return negatif + duration.minutes() + 'min ' + duration.seconds() + 's'
    else if(durationMs >= 1000) return negatif + duration.seconds() + 's' //+ duration.milliseconds() + 'ms'
    else if(durationMs == 0) return  ''
    else return negatif + duration.milliseconds() + ' ms'    
  }
})

Vue.filter('formatDuration', function(value:number,i18n:VueI18n,forceShowSecond:boolean = false) {
  if (value || value===0) {      
    const negatif = value < 0?"-":""
    const duration = moment.duration(Math.abs(value))
    const durationMs = duration.asMilliseconds()

    if(isNaN(durationMs)) return ''
    
    if(durationMs >= 24 * 60 * 60 * 1000) return negatif + duration.asDays().toFixed(1) + ' '+ i18n.tc('Pilot.MissionDrawer.Days', parseFloat(duration.asDays().toFixed(1)))
    else if(durationMs >= 60 * 60 * 1000) return negatif + duration.hours() + 'h ' + (duration.minutes() > 0?duration.minutes() + 'min':'') + (forceShowSecond?(' ' + duration.seconds() + 's'):'')
    else if(durationMs >= 60 * 1000) return negatif + duration.minutes() + 'min ' + (duration.seconds()> 0?duration.seconds() + 's':'')
    else if(durationMs >= 1000) return negatif + duration.seconds() + 's' //+ duration.milliseconds() + 'ms'
    else if(durationMs == 0) return  i18n.t('Pilot.MissionDrawer.None')
    else return negatif + duration.milliseconds() + ' ms'    
  }
})